import React, { useEffect, useState, useRef } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext';
import { useSwipeable } from 'react-swipeable'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import QuickCaption from './quick-caption'

import * as styles from "~/styles/blog/img-cols.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const SwipeImgCols = ({ blockId, index }) => {
  const { isMobile, isTouches } = useTheme()
  const { post, props } = usePost()
  const { quickProds } = props
  const blogTitle = post.title
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const [didLoad, setDidLoad] = useState(false)
  const [pos, setPos] = useState(0)

  const wrapRef = useRef(null)

  const images = []

  if ( notBlank(settings.img1_img) ) {
    const obj = {
      type: 'image1',
      image: imgSize(settings.img1_img,900),
      scale: parseInt(settings.img1_scale),
      smaller: parseInt(settings.img1_scale) < parseInt(settings.img2_scale),
      link: notBlank(settings.img1_link) ? settings.img1_link : false,
      credit: settings.img1_credit,
      title: notBlank(settings.img1_title) ? settings.img1_title : false,
      copy: notBlank(settings.img1_copy) ? settings.img1_copy : false,
      cta: notBlank(settings.img1_cta) ? settings.img1_cta : false,
      align: notBlank(settings.img1_align) ? settings.img1_align : false
    }
    images.push(obj)
  }
  if ( notBlank(settings.img2_img) || notBlank(settings.img2_copy) ) {
    const obj = {
      type: 'image2',
      image: settings.img2_img ? imgSize(settings.img2_img,900) : false,
      scale: parseInt(settings.img2_scale),
      smaller: parseInt(settings.img2_scale) < parseInt(settings.img1_scale),
      link: notBlank(settings.img2_link) ? settings.img2_link : false,
      credit: settings.img2_credit,
      title: notBlank(settings.img2_title) ? settings.img2_title : false,
      copy: notBlank(settings.img2_copy) ? settings.img2_copy : false,
      cta: notBlank(settings.img2_cta) ? settings.img2_cta : false,
      align: notBlank(settings.img2_align) ? settings.img2_align : false
    }
    images.push(obj)
  }

  if ( isMobile && notBlank(settings.img3_img) ) {
    const obj = {
      type: 'image3',
      image: imgSize(settings.img3_img,900),
      scale: parseInt(settings.img3_scale),
      smaller: parseInt(settings.img3_scale) < parseInt(settings.img1_scale),
      link: notBlank(settings.img3_link) ? settings.img3_link : false,
      credit: settings.img3_credit,
      title: notBlank(settings.img3_title) ? settings.img3_title : false,
      copy: notBlank(settings.img3_copy) ? settings.img3_copy : false,
      cta: notBlank(settings.img3_cta) ? settings.img3_cta : false,
      align: notBlank(settings.img3_align) ? settings.img3_align : false
    }
    images.push(obj)
  }

  let classes = []
  if (settings.no_margin) classes.push(styles.no_margin)
  const same_size = parseInt(settings.img1_scale) === parseInt(settings.img2_scale) 
  if (same_size) classes.push(styles.same_size)
  if (images.length > 2) classes.push(styles.nd_tre)
  classes = classes.join(' ')
  

  const total = images.length - 1

  const getPerc = (delta) => {
    const timew = wrapRef.current.getBoundingClientRect().width
    const perc = ((delta)/timew)*100
    return perc < -100 ? -100 : perc > 100 ? 100 : perc
  }
  const [currTrans, setCurrTrans] = useState(0)
  const [change, setChange] = useState(0)
  const [deltaX, setDeltaX] = useState(0)
  
  useEffect(() => {
    if (deltaX === 0) return
    const intervalId = setInterval(() => {
      setDeltaX(prevDeltaX => prevDeltaX > 0 ? prevDeltaX - 1 : 0);
      setCurrTrans(prevTrans => Math.abs(prevTrans) <= 0 ? 0 : prevTrans - change);
    }, 1); 

    return () => {
      clearInterval(intervalId);
      if (deltaX <= 0 && currTrans <= -100) {
        setPos( pos + 1 > total ? pos : pos + 1 )
        setCurrTrans(0)
      }
      if (deltaX <= 0 && currTrans >= 100) {
        setPos( pos - 1 < 0 ? pos : pos - 1 )
        setCurrTrans(0)
      }
    };
  }, [deltaX, change, pos, currTrans, total])

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches) return
      if (e.dir === 'Right' && pos !== 0) setCurrTrans( getPerc(e.deltaX) )
      if (e.dir === 'Left' ) setCurrTrans( getPerc(e.deltaX) )
    },
    onSwipedLeft: (e) => {
      if (!isTouches ) return
      if (pos === total) return

      const delta = getPerc(e.absX)
      if ( delta > 30 ) {
        setChange(1)
        setDeltaX(100 - delta)
      } else {
        setChange(-1)
        setDeltaX(delta)
      }
    },
    onSwipedRight: (e) => {
      if (!isTouches) return
      if (pos === 0) return

      const delta = getPerc(e.absX)
      if ( delta > 30 ) {
        setChange(-1)
        setDeltaX(100 - delta)
      } else {
        setChange(1)
        setDeltaX(delta)
      }
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  })

  useEffect(() => {
    setDidLoad(true)

  }, [])

  return (
    <div 
      className={styles.swipe_colwr}
      block={block.id}
      ref={wrapRef} 
    >
      <div 
        className={jnstyls([bstyle.sec, styles.img_cols, styles.swipe_cols, classes])}
        {...swipers}
      >
        {didLoad && images.map( (item, tindex) => {

          let trans = {}

          if (didLoad && isMobile) {
            trans = tindex < pos ? '-120%' : tindex === pos ? '0' : '120%'
            trans = `translate(${trans}, 0)`
            if (tindex < (pos - 1) || tindex > (pos + 1)) {
              trans = tindex < pos ? '-120%' : '120%'
            } else {
              trans = tindex < pos ? `${-100 + currTrans}%` : tindex > pos ? `${100 + currTrans}%` : `${currTrans}%`
            }
            trans = {transform: `translate(${trans}, 0)`}
          }

          return (
            <div 
              key={`two_${index}${tindex}`}
              className={jnstyls([styles.item, `imgcols_${block.id}${tindex}`, item.smaller ? styles.smaller : ''])}
              aria-hidden={pos === tindex ? 'true' : 'false'} 
              carou-item={pos === tindex? '' : undefined}
              style={trans}
              swipecol=''
            > 
              {(notBlank(item.title) && item.title_above) && (
                <div className={styles.title_wr}>
                  {item.link ? (
                    <div className={jnstyls([bstyle.title, styles.title])}>
                      <Flink 
                        href={item.link} 
                        className={bstyle.title_link} 
                        aria-label={item.title} 
                        dangerouslySetInnerHTML={{ __html: item.title }} 
                      />
                    </div>
                  ) : (
                    <div className={jnstyls([bstyle.title, styles.title])} dangerouslySetInnerHTML={{ __html: item.title }} />
                  )}
                </div>
              )}
              <div 
                className={jnstyls([styles.image, item.credit ? bstyle.image_credit : ''])} 
              > 
                {item.image && (
                  <>
                    {item.link ? (
                      <Flink href={item.link} className="">
                        <img 
                          className={styles.img}
                          src={item.image}
                          alt={notBlank(item.credit) ? item.credit : notBlank(item.title) ? `${item.title} ${tindex}` : `${blogTitle} two images - ${tindex + 1}`} 
                          width={450} height={600} 
                        />
                      </Flink>
                    ) : (
                      <img 
                        className={styles.img}
                        src={item.image}
                        alt={notBlank(item.credit) ? item.credit : notBlank(item.title) ? `${item.title} ${tindex}` : `${blogTitle} two images - ${tindex + 1}`} 
                        width={450} height={600} 
                      />
                    )}
                    {item.credit && (
                      <div className={bstyle.credit}>{item.credit}</div>
                    )}
                  </>
                )}
              </div>
              {(notBlank(item.title) || notBlank(item.copy) || notBlank(item.cta)) && (
                <div 
                  className={jnstyls([styles.caption, item.align !== 'left' ? styles[`caption_a${item.align}`] : ''])} 
                >
                  {item.title && (
                    <>
                      {item.link ? (
                        <div className={jnstyls([bstyle.title, styles.title])}>
                          <Flink 
                            href={item.link} 
                            className={bstyle.title_link} 
                            aria-label={item.title} 
                            dangerouslySetInnerHTML={{ __html: item.title }} 
                          />
                        </div>
                      ) : (
                        <div className={jnstyls([bstyle.title, styles.title])} dangerouslySetInnerHTML={{ __html: item.title }} />
                      )}
                    </>
                  )}
                  {item.copy && (
                    <>
                      {(quickProds && item.copy?.includes('/products/') && !!quickProds.length) ? (
                        <QuickCaption 
                          copy={item.copy} 
                          styles={styles.copy_body}
                        />
                      ) : (
                        <div className={styles.copy_body} dangerouslySetInnerHTML={{ __html: item.copy }} />
                      )}
                    </>
                  )}
                  {(item.cta && item.link) && (
                    <div className={styles.copy_cta}>
                      <Flink href={item.link} className={bstyle.cta_link}><span>{item.cta}</span></Flink>
                    </div>
                  )}
                </div>
              )}

              <style>
                {`@media only screen and (min-width: 800px) {
                  .imgcols_${block.id}${tindex} .${styles.image},
                  .imgcols_${block.id}${tindex} .${styles.caption} {
                    width: ${item.scale}%;
                  }
                }`}
              </style>
          </div>
        )})}
      </div>
      {(didLoad && isMobile && images.length > 1) && (
        <div 
          className={styles.indicate}
        >
          {images.map((x,index) => 
            <div key={`dot${index}`} className={[styles.ind_dot, pos === index ? styles.curr : ''].join(' ')} />
          )}
        </div>
      )}
    </div>
  )
}

export default SwipeImgCols